import { NgModule } from '@angular/core';
import { CommonStopPropagationDirective } from './stop_propagation.directive';
import { CommonPreventDefaultDirective } from './prevent_default.directive';
import { CommonAutofocusDirective } from './autofocus.directive';
import { CommonDotdotdotDirective } from './dotdotdot.directive';
import { CommonLowerCaseInputDirective } from './lower_case_input';

@NgModule({
	declarations: [
		CommonPreventDefaultDirective,
		CommonStopPropagationDirective,
		CommonAutofocusDirective,
		CommonDotdotdotDirective,
		CommonLowerCaseInputDirective,
	],
	exports: [
		CommonPreventDefaultDirective,
		CommonStopPropagationDirective,
		CommonAutofocusDirective,
		CommonDotdotdotDirective,
		CommonLowerCaseInputDirective,
	],
})
export class CommonDirectivesModule {}
